import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { Button } from "cxa-components";
import { fetchProducts } from "actions/marketplaceActions";
import ProductItem from "./ProductItem";
import messages from "components/messagesDescription";

const ProductList = ({ fetchProducts, products, intl, providerId, isFetching }) => {
  useEffect(() => {
    if (products.initRender) {
      fetchProducts(products.params);
    }
  }, []);

  const loadMoreProducts = () => {
    !isFetching && fetchProducts(products.params);
  };

  return (
    <div className="product-list-container">
      <strong>
        <u style={{ marginLeft: "10px" }}>
          {intl.formatMessage(messages.marketplace.productsLabel)}:
        </u>
      </strong>
      <div className="card-container">
        {products.data.map(item => {
          return <ProductItem key={item.productId} product={item} providerId={providerId} />;
        })}
      </div>
      {products.showMore && (
        <Button onClick={loadMoreProducts} primary className="load-more-btn">
          {intl.formatMessage(messages.marketplace.seeMoreLabel)}
        </Button>
      )}
    </div>
  );
};
ProductList.propTypes = {
  providerId: PropTypes.string.isRequired,
  products: PropTypes.object.isRequired,
  fetchProducts: PropTypes.func.isRequired,
  intl: PropTypes.object,
  isFetching: PropTypes.bool,
};

const mapStateToProps = ({ marketplace: { products, isFetching } }) => {
  return {
    products,
    isFetching,
  };
};

const mapDispatchToProps = {
  fetchProducts,
};
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ProductList));



// WEBPACK FOOTER //
// ./components/marketplace/ProductList.jsx